/* eslint-disable no-unused-vars */
/* eslint-disable prefer-destructuring */
/* eslint-disable no-plusplus */
/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable no-param-reassign */
import {
  Box,
  LinearProgress,
  MenuItem,
  Paper,
  Table,
  TableBody,
  TableFooter,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import {
  addMonths,
  addYears,
  eachMonthOfInterval,
  eachYearOfInterval,
} from 'date-fns';
import React, {
  useCallback,
  useContext,
  useEffect,
  useState,
  useMemo,
} from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import api, { authHeader } from '../../../../../../services/API/apiConfig';
import ToasterBox from '../../../../../components/singleComponents/toaster/ToasterBox';

import { TourContext } from '../../../../../../context/tour';
import {
  BtnStyled,
  CellInputStyled,
  CellStepsStyled,
  DateInputStyled,
  FrequencyInputStyled,
  HeaderBoxStyled,
  IconStyled,
  InputBoxStyled,
  ItemNumStyled,
  LinearProgressStyled,
  LoadingProgressStyled,
  NameStyled,
  PeriodsInputStyled,
  RootStyled,
  TableCellFixedStyled,
  TableCellHeaderFixedStyled,
  TableCellFooterFixedStyled,
  TableCellHeaderStickyStyled,
  TableCellHeaderStyled,
  TableCellStyled,
  TableContainerStyled,
  TableRowStyled,
  TimelineNoneStyled,
} from './ConstructionTimeline.styles';

export function ConstructionTimeline() {
  const navigate = useNavigate();
  const { id } = useParams();

  const { tutorialStep, setTutorialStep, isDialogOn } = useContext(TourContext);

  const [constructionData, setConstructionData] = useState();
  const [tableData, setTableData] = useState({});
  const [frequency, setFrequency] = useState('');
  const [periods, setPeriods] = useState(1);
  const [initialDate, setInitialDate] = useState('');
  const [hasSchedule, setHasSchedule] = useState(false);
  const [totalPercentage, setTotalPercentage] = useState([]);
  const [percentageValues, setPercentageValues] = useState([]);
  const [headerData, setHeaderData] = useState([]);
  const headerFrequency = headerData.slice(0, periods);

  const [toaster, setToaster] = useState(false);

  const [hasBudget, setHasBudget] = useState(true);
  const [loading, setLoading] = useState(true);

  const frequencyOptions = [
    { value: 'weekly', label: 'Semanal' },
    { value: 'biweekly', label: 'Quinzenal' },
    { value: 'monthly', label: 'Mensal' },
    { value: 'quarterly', label: 'Trimestral' },
    { value: 'annualy', label: 'Anual' },
  ];

  const periodsArr = [];
  for (let i = 0; i < periods; i += 1) {
    periodsArr.push(i + 1);
  }

  const budgetToaster = useMemo(() => !hasBudget, [hasBudget]);

  function getHeaderFrequency() {
    const date = new Date(initialDate);
    const periodsNum = periods === '' ? 0 : periods - 1;
    const monthsOptions = [
      'JAN',
      'FEV',
      'MAR',
      'ABR',
      'MAI',
      'JUN',
      'JUL',
      'AGO',
      'SET',
      'OUT',
      'NOV',
      'DEZ',
    ];
    const newHeader = [...headerData];

    if (frequency === 'weekly') {
      periodsArr.forEach((data, i) => {
        newHeader[i] = `SEMANA ${i + 1}`;
      });
    } else if (frequency === 'biweekly') {
      const periodsIteration = periodsNum / 2 + 1;
      const endBiWeek = addMonths(date, periodsIteration);
      const biWeekArray = eachMonthOfInterval({ start: date, end: endBiWeek });
      const tempArr = [];

      biWeekArray.forEach((mon) => {
        tempArr.push(`${monthsOptions[mon.getMonth()]} 1/2`);
        tempArr.push(`${monthsOptions[mon.getMonth()]} 2/2`);
      });
      if (date.getDate() > 15) {
        tempArr.shift();
      }
      periodsArr.forEach((data, i) => {
        newHeader[i] = tempArr[i];
      });
    } else if (frequency === 'monthly') {
      const endMonth = addMonths(date, periodsNum);
      const monthsArray = eachMonthOfInterval({ start: date, end: endMonth });

      monthsArray.forEach((mon, idx) => {
        newHeader[idx] = `${
          monthsOptions[mon.getMonth()]
        } / ${mon.getFullYear()}`;
      });
    } else if (frequency === 'quarterly') {
      const endQuarterly = addMonths(date, periods * 3);
      const quarterlyArray = eachMonthOfInterval({
        start: date,
        end: endQuarterly,
      });
      const quarters = [];
      const totalMonths = [];

      quarterlyArray.forEach((data, i) => {
        totalMonths.push(monthsOptions[quarterlyArray[i].getMonth()]);
      });
      for (let b = 0; b < totalMonths.length; b += 3) {
        const chunk = totalMonths.slice(b, b + 3);
        quarters.push(chunk);
      }
      quarters.forEach((data, i) => {
        newHeader[i] = data.join('/');
      });
    } else if (frequency === 'annualy') {
      const endYears = addYears(date, periodsNum);
      const yearsArray = eachYearOfInterval({ start: date, end: endYears });

      yearsArray.forEach((data, i) => {
        newHeader[i] = data.getFullYear();
      });
    }
    setHeaderData(newHeader);
  }

  const getDataCallback = useCallback(async () => {
    await api
      .get(`/constructions/${id}/details?budget=false`, {
        headers: authHeader(),
      })
      .then((res) => {
        const { data } = res.data;
        setConstructionData(data);
      });

    const budgetItems = [];
    await api
      .get(`/constructions/${id}/budgets`, {
        headers: authHeader(),
      })
      .then((res) => {
        const { data } = res.data;
        if (Array.isArray(data)) {
          setHasBudget(false);
        } else {
          setHasBudget(!!data.items_attributes.length);
          const getItems = (item) => {
            if (item.items_attributes.length === 0) {
              budgetItems.push({ id: item.id, description: item.description });
            }
            item.items_attributes.forEach((i) => {
              getItems(i);
            });
          };

          data.items_attributes.forEach((item) => {
            getItems(item);
          });
        }
      });

    await api
      .get(`/constructions/${id}/schedules`, {
        headers: authHeader(),
      })
      .then((res) => {
        const { data } = res.data;

        if (data.id) {
          // TODO: mudar de foreach para for ou map
          data.schedule_items.forEach((i) => {
            const isLeaf = budgetItems.find((leaf) => leaf.id === i.id);
            // eslint-disable-next-line no-param-reassign
            i.isLeaf = !!isLeaf;
          });

          setHasSchedule(true);
          setTableData(data);
          setFrequency(data.frequency);
          setPeriods(data.periods);
          const convertedDate = data.starts_at.split('/').reverse().join('/');
          setInitialDate(convertedDate);
          setLoading(false);

          const savedItems = [...percentageValues];
          const newPercentage = [...totalPercentage];
          // creates an array for each data.schedule_items with the values from schedule_data
          data.schedule_items?.forEach((scheduleItem, scheduleIndx) => {
            scheduleItem.schedule_data?.forEach((schedulePeriod, itemIndx) => {
              // if the values in schedule_data.period are not linear, adds 0 in the missing periods
              const periodIdx = itemIndx + 1;
              const itemsIndex = schedulePeriod.period - 1;
              if (schedulePeriod.period > periodIdx) {
                for (let b = 0; b < itemsIndex; b++) {
                  if (savedItems[scheduleIndx][b] === null) {
                    savedItems[scheduleIndx][b] = 0;
                  }
                }
                savedItems[scheduleIndx][itemsIndex] =
                  schedulePeriod.percentage;
              } else if (savedItems.length) {
                savedItems[scheduleIndx][itemIndx] = schedulePeriod.percentage;
              }
            });
            newPercentage[scheduleIndx] =
              savedItems[scheduleIndx]?.reduce((p, c) => p + c, 0) || 0;
          });
          setPercentageValues(savedItems);
          setTotalPercentage(newPercentage);
        } else if (!data.length) {
          setLoading(false);
        }
      });
  }, []);

  useEffect(() => {
    getDataCallback();
  }, [getDataCallback]);

  useEffect(() => {
    if (initialDate !== '' && +initialDate.slice(0, 4) >= 2000) {
      getHeaderFrequency();
    }
  }, [periods, frequency, initialDate]);

  function navigateNewTimeline() {
    if (!frequency || !initialDate || !periods || Number(periods) <= 0) {
      setToaster(true);
      setTimeout(() => {
        setToaster(false);
      }, 1500);
      return;
    }
    if ((frequency !== '' || periods !== 0) && hasSchedule) {
      navigate(`/new-timeline/${id}`);
      return;
    }

    const data = {
      schedule: {
        frequency,
        periods,
        starts_at: initialDate.split('/').reverse().join('/'),
      },
    };

    api
      .post(`/constructions/${id}/schedules`, data, {
        headers: authHeader(),
      })
      .then(() => {
        navigate(`/new-timeline/${id}`);
      });
  }

  function getTableRowClass(num) {
    const dots = num.split('').filter((character) => character === '.').length;

    if (dots === 0) return 'primary-item';
    if (dots === 1) return 'secondary-item';
    return 'tertiary-item';
  }

  const getBgColor = (num) => {
    const dots = num.split('').filter((character) => character === '.').length;

    if (dots === 0) return '#9fd5d5';
    if (dots === 1) return '#c6e4e4';
    return '#edf6f5';
  };

  function checkTotalPercentage(idxRow) {
    const total = tableData.schedule_items[idxRow].schedule_data.length
      ? tableData.schedule_items[idxRow].schedule_data.reduce(
          (acc, curr) => acc + curr.percentage,
          0
        )
      : 0;

    let color = '#000000';

    if (total !== undefined && total === 100) {
      color = '#508239';
    } else if (total !== undefined && total > 100) {
      color = '#f51f0e';
    } else if (total !== undefined && total > 0) {
      color = '#eb7d36';
    }

    return <span style={{ color, fontWeight: 600 }}>{`${total} %`}</span>;
  }

  return (
    <Paper>
      <RootStyled>
        <HeaderBoxStyled>
          <Box>
            <NameStyled variant="h1">
              {constructionData ? constructionData.name : ''}
            </NameStyled>
            <Typography variant="body2">
              {constructionData ? constructionData.square_meters : ''} m²
            </Typography>
            <Typography variant="body2">
              Total orçado:{' '}
              <span style={{ color: '#64A348' }}>
                {constructionData
                  ? new Intl.NumberFormat('pt-BR', {
                      style: 'currency',
                      currency: 'BRL',
                    }).format(constructionData.total_budget)
                  : ''}
              </span>
            </Typography>
            <Typography variant="body2">
              Total/m² orçado:{' '}
              <span style={{ color: '#64A348' }}>
                {constructionData
                  ? new Intl.NumberFormat('pt-BR', {
                      style: 'currency',
                      currency: 'BRL',
                    }).format(constructionData.total_budget_per_m2)
                  : ''}
              </span>
            </Typography>
          </Box>
          {!hasSchedule && (
            <>
              {toaster && <ToasterBox message="Preencha todos os dados!" />}
              {budgetToaster && (
                <ToasterBox message="Não é possível criar ou visualizar um cronograma sem que exista um orçamento criado" />
              )}
              <span>
                <BtnStyled
                  id="create-schedule"
                  disabled={!hasBudget}
                  onClick={() => navigateNewTimeline()}
                >
                  Criar cronograma
                </BtnStyled>
              </span>
            </>
          )}
        </HeaderBoxStyled>
        <HeaderBoxStyled>
          <InputBoxStyled>
            <FrequencyInputStyled
              id="frequency-input"
              disabled={hasSchedule}
              label="Periodicidade"
              variant="outlined"
              value={frequency}
              onChange={(e) => setFrequency(e.target.value)}
              select
              SelectProps={{
                MenuProps: {
                  anchorOrigin: { vertical: 'bottom', horizontal: 'left' },
                  getContentAnchorEl: null,
                },
              }}
            >
              {frequencyOptions.map((option) => (
                <MenuItem key={option.value} value={option.value}>
                  {option.label}
                </MenuItem>
              ))}
            </FrequencyInputStyled>
            <PeriodsInputStyled
              id="periods-input"
              disabled={hasSchedule}
              label="Qtd de períodos"
              variant="outlined"
              type="number"
              value={periods}
              helperText={Number(periods) <= 0 && 'Deve ser maior do que zero'}
              onChange={(e) => {
                let value = e.target.value;
                if (value > 60) {
                  value = 60;
                }
                setPeriods(e.target.value);
              }}
              slotProps={{
                inputLabel: { shrink: true },
              }}
              error={Number(periods) <= 0}
            />
            <DateInputStyled
              id="initial-date-input"
              type="date"
              label="Data inicial do cronograma"
              variant="outlined"
              disabled={hasSchedule}
              value={initialDate.split('/').join('-')}
              slotProps={{
                inputLabel: { shrink: true },
              }}
              inputProps={{ max: '9999-12-31' }}
              onChange={(e) =>
                setInitialDate(e.target.value.split('-').join('/'))
              }
            />
          </InputBoxStyled>
          {hasSchedule && (
            <BtnStyled id="edit-schedule" onClick={() => navigateNewTimeline()}>
              Editar cronograma
            </BtnStyled>
          )}
        </HeaderBoxStyled>
        {loading ? (
          <LoadingProgressStyled>
            <Typography variant="h2">Carregando...</Typography>
            <LinearProgress style={{ width: '80%' }} />
          </LoadingProgressStyled>
        ) : (
          <>
            {hasSchedule ? (
              <TableContainerStyled id="schedules-table">
                <Table stickyHeader>
                  <TableHead>
                    <TableRow>
                      <TableCellHeaderStickyStyled>
                        ETAPAS DO PROJETO
                      </TableCellHeaderStickyStyled>
                      <TableCellHeaderFixedStyled>%</TableCellHeaderFixedStyled>
                      {headerFrequency.map((data, i) => (
                        // eslint-disable-next-line react/no-array-index-key
                        <TableCellHeaderStyled key={i}>
                          {data}
                        </TableCellHeaderStyled>
                      ))}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {tableData.schedule_items &&
                      tableData.schedule_items.map((row, idxRow) => {
                        if (percentageValues.length < 1) {
                          tableData.schedule_items.forEach(() => {
                            percentageValues.push([]);
                          });
                        }
                        return (
                          <TableRowStyled
                            key={row.id}
                            className={getTableRowClass(row.item_num)}
                          >
                            <CellStepsStyled
                              className={getTableRowClass(row.item_num)}
                            >
                              <ItemNumStyled>{row.item_num}</ItemNumStyled>
                              {row.description}
                            </CellStepsStyled>
                            <TableCellFixedStyled
                              className={getTableRowClass(row.item_num)}
                            >
                              {row.isLeaf ? checkTotalPercentage(idxRow) : ''}
                            </TableCellFixedStyled>

                            {periodsArr.map((cell) => {
                              const rowItem = row.schedule_data.find(
                                (a) => a.period === cell
                              );

                              const getProgress = () => {
                                if (!rowItem) return 0;
                                if (rowItem.percentage > 100) return 100;
                                return rowItem.percentage;
                              };

                              return row.isLeaf ? (
                                <TableCellStyled key={cell}>
                                  <>
                                    <CellInputStyled>
                                      {rowItem ? rowItem.percentage : 0}
                                    </CellInputStyled>
                                    <LinearProgressStyled
                                      variant="determinate"
                                      value={getProgress()}
                                    />
                                  </>
                                </TableCellStyled>
                              ) : (
                                <TableCellStyled key={cell}>
                                  &nbsp;
                                </TableCellStyled>
                              );
                            })}
                          </TableRowStyled>
                        );
                      })}
                  </TableBody>
                  <TableFooter>
                    <TableRow>
                      <TableCellFooterFixedStyled colSpan={2}>
                        ORÇAMENTO DO PERÍODO
                      </TableCellFooterFixedStyled>
                      {tableData.budget_per_period?.map((budget) => (
                        <TableCellHeaderStyled key={budget.period}>
                          {new Intl.NumberFormat('pt-BR', {
                            style: 'currency',
                            currency: 'BRL',
                          }).format(budget.total)}
                        </TableCellHeaderStyled>
                      ))}
                    </TableRow>
                  </TableFooter>
                </Table>
              </TableContainerStyled>
            ) : (
              <TimelineNoneStyled>
                <IconStyled />
                <Typography>
                  Nenhum cronograma foi adicionado até o momento.
                </Typography>
              </TimelineNoneStyled>
            )}
          </>
        )}
      </RootStyled>
    </Paper>
  );
}
